import React, { useContext, useEffect, useState } from 'react';
import styles from './Image.module.scss';
import Lottie from 'lottie-react';
import { addCustomPathToLink, generateKey, sanitizeType } from '../../../../functions';
import { DataContext } from '../../../../views/pages/Root';

const Image = ({ properties, type, animationData }) => {
  const data = useContext(DataContext);
  const [animation, setAnimation] = useState();

  useEffect((_) => {
    if (!!properties?.animationName) {
      setAnimation(!!data?.animations2?.length && data.animations2.find((prop) => prop.name == properties.animationName));
    }
  }, []);

  return (
    <div
      data-aos={animationData?.animation}
      data-aos-offset={animationData?.animationOffset}
      data-aos-delay={animationData?.animationDelay}
      data-aos-duration={animationData?.animationDuration}
      data-aos-easing={animationData?.animationEasing}
      data-aos-anchor-placement={animationData?.animationAnchor}
      className={`${styles.sectionImage} ${sanitizeType(type, styles)}`}
    >
      {(!!properties?.image || !!properties?.animationName) && (
        <figure className={styles.imageBox} key={!!properties?.image ? properties.image.id : generateKey()}>
          {!!animation && <Lottie autoplay="true" animationData={animation?.value} loop={true} className={styles.animationOnImage}></Lottie>}
          {!!properties?.image && <img className={styles.image} src={addCustomPathToLink(properties.image.src, true)} alt={properties.image.alt} />}
        </figure>
      )}
    </div>
  );
};
export default Image;
